import { render, staticRenderFns } from "./login-container.vue?vue&type=template&id=260e7b2e"
import script from "./login-container.vue?vue&type=script&lang=js"
export * from "./login-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260e7b2e')) {
      api.createRecord('260e7b2e', component.options)
    } else {
      api.reload('260e7b2e', component.options)
    }
    module.hot.accept("./login-container.vue?vue&type=template&id=260e7b2e", function () {
      api.rerender('260e7b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/login/components/login-container.vue"
export default component.exports